export default __webpack_public_path__ + "static/media/placeholder_bear_light.2c795093.png";